import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=1892ec28&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=1892ec28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892ec28",
  null
  
)

export default component.exports